/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-unused-expressions */
import React, { useContext, useEffect, useRef, useState } from 'react';
import { Form, Formik, Field } from 'formik';
import { useHistory, useLocation } from 'react-router-dom';
import Layout from 'components/Layout';
import { ButtonContent } from './styles';
import { FitinsurAPI, MessageCenter } from 'utils';
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import StepNavigation from 'components/StepNavigation';
import BrokingSummary from 'components/BrokingSummary';
import {
	Button,
	ButtonContainer,
	LostCancelButton,
	FileModal,
	HasPermission
} from '@fitinsur/components'
import { Content, } from './styles';
import {
	useGetDocuments,
	useGetDocumentsAsync
} from '@fitinsur/services/DocumentsService';
import { LoaderContext } from '@fitinsur/contexts'
import { useGetOperationAsync, useUpdateOperationSync } from 'services/OperationService';
import { ModalEditConfirmation } from 'components';
import * as yup from 'yup';
import { isEmpty } from 'lodash';
import {
	useSaveQuestionnaireAnswerSync,
	useGetQuestionnaireAnswer
} from 'services/QuestionnaireAnswerService';
import {
	useRequestIssueAction,
	useRequestSompoGetInternalProcessNumber,
	useRequestSompoGetIssueQuotePolicy,
	useSignatureDocumentSompo
} from 'services/IssueService';
import {
	useCheckConsumption
} from '@fitinsur/services/CreditLimitService';
import moment from 'moment';

export default function CCGClauses({ permissions, ...props }) {
	const { updateIsLoadingStatus } = useContext(LoaderContext);
	const history = useHistory();
	const formikRef = useRef({});
	const mc = new MessageCenter();
	const [questionnaire, setQuestionnaire] = useState([])
	const [operation, setOperation] = useState({});
	const [documents, setDocuments] = useState([]);
	const [dialogConfirmationEmission, setDialogConfirmationEmission] = useState({ visible: false });
	const [isBound, setIsBound] = useState(false);

	const validationSchema = useRef(yup.object().shape({}));
	const handleBack = () => history.goBack();
	const getQuestionnaire = useRef(false);

	const {
		data: useGetDocumentsData,
		loading: useGetDocumentsLoading,
		error: useGetDocumentsError,
		status: useGetDocumentsStatus,
		request: useGetDocumentsRequest
	} = useGetDocuments(props.match.params.idOperation);

	const {
		data: useGetQuestionnairesAnswersData,
		loading: useGetQuestionnairesAnswersLoading,
		status: useGetQuestionnairesAnswersStatus,
		request: useGetQuestionnairesAnswersRequest,
	} = useGetQuestionnaireAnswer(props.match.params.idOperation);

	const {
		loading: useRequestSompoGetInternalProcessNumberLoading,
		request: useRequestSompoGetInternalProcessNumberRequest,
	} = useRequestSompoGetInternalProcessNumber();

	const {
		status: useRequestSompoGetIssueQuotePolicyStatus,
		loading: useRequestSompoGetIssueQuotePolicyLoading,
		request: useRequestSompoGetIssueQuotePolicyRequest,
	} = useRequestSompoGetIssueQuotePolicy();

	const {
		loading: useGetOperationLoading,
		request: useGetOperationRequest
	} = useGetOperationAsync(props.match.params.idOperation);

	const {
		loading: useSaveQuestionnaireAnswerLoading,
		status: useSaveQuestionnaireAnswerStatus,
		request: useSaveQuestionnaireAnswerRequest,
	} = useSaveQuestionnaireAnswerSync(props.match.params.idOperation);

	const {
		loading: useUpdateOperationLoading,
		request: useUpdateOperationRequest
	} = useUpdateOperationSync(props.match.params.idOperation);

	const {
		loading: useRequestIssueActionLoading,
		request: useRequestIssueActionRequest,
	} = useRequestIssueAction();

	const {
		loading: useCheckConsumptionLoading,
		request: useCheckConsumptionRequest,
	} = useCheckConsumption(props?.match?.params?.idOperation);

	const {
		loading: useGetDocumentsAsyncLoading,
		request: useGetDocumentsAsyncRequest
	} = useGetDocumentsAsync(props?.match?.params?.idOperation);

	const {
		loading: useSignatureDocumentSompoRequestLoading,
		request: useSignatureDocumentSompoRequest
	} = useSignatureDocumentSompo();

	useEffect(() => {
		if (useGetQuestionnairesAnswersStatus === 200) {
			handleQuestionnaire(useGetQuestionnairesAnswersData?.value)
		}
	}, [useGetQuestionnairesAnswersStatus]);


	useEffect(() => {
		updateIsLoadingStatus(
			useGetDocumentsLoading ||
			useGetOperationLoading ||
			useSaveQuestionnaireAnswerLoading ||
			useRequestSompoGetIssueQuotePolicyLoading ||
			useRequestSompoGetInternalProcessNumberLoading ||
			useGetQuestionnairesAnswersLoading ||
			useUpdateOperationLoading ||
			useRequestIssueActionLoading ||
			useCheckConsumptionLoading ||
			useGetDocumentsAsyncLoading ||
			useSignatureDocumentSompoRequestLoading
		)
	}, [
		useGetDocumentsLoading,
		useGetOperationLoading,
		useSaveQuestionnaireAnswerLoading,
		useRequestSompoGetIssueQuotePolicyLoading,
		useRequestSompoGetInternalProcessNumberLoading,
		useGetQuestionnairesAnswersLoading,
		useUpdateOperationLoading,
		useRequestIssueActionLoading,
		useCheckConsumptionLoading,
		useGetDocumentsAsyncLoading,
		useSignatureDocumentSompoRequestLoading
	]);

	useEffect(() => {
		async function start() {
			if (getQuestionnaire.current) return;
			if (isEmpty(permissions)) return;
			try {
				await useGetQuestionnairesAnswersRequest();
			} catch (e) {
				updateIsLoadingStatus(false);
			}
			getQuestionnaire.current = true
		}
		start();

	}, [permissions])

	useEffect(() => {
		if (props.match.params.idOperation) {
			useGetOperationRequest(null, { loadLastDocument: true }).then(response => {
				let operationData;
				if (response.status === 200) {
					operationData = response.data?.value;
					setOperation(operationData);
					useGetDocumentsRequest(null, { idDomain: [261] });
					setIsBound([5, 2, 6, 187, 133, 158, 187, 263, 104, 99, 159, 140, 177, 188, 198, 176, 403].includes(operationData?.idDomainStatus))
				}
			});
		}
	}, []);

	useEffect(() => {
		if (!useGetDocumentsStatus) return;

		if (useGetDocumentsStatus === 200) {
			if (useGetDocumentsData.value.length) {
				setDocuments(useGetDocumentsData.value.map(doc => ({
					idDocument: doc.idDocument,
					idDomainDescription: doc.idDomainDescription,
					idReport: doc.idReport,
					idOperation: doc.idOperation,
					reportToken: doc.reportToken,
					url: doc.url,
					fileName: doc.documentMetadata.fileName
				})))
			}
		}
	}, [useGetDocumentsStatus]);


	const handleQuestionnaire = async (data) => {
		try {
			formikRef.current.setValues({});
			setQuestionnaire([]);
			setTimeout(() => {
				let questionnaire = [];
				questionnaire = [
					...data.persons,
					...data.operations,
					...data.payments,
					...data.risks
				];
				questionnaire = questionnaire.sort((a, b) => a.sequenceQuestion - b.sequenceQuestion);

				setQuestionnaire(questionnaire);
			}, 300)
		} catch (e) {
			console.log(e)
		}
	}

	const handleCheckConsumption = async (isIssue = true) => {
		try {
			const { data: consumptionData } = await useCheckConsumptionRequest({}, { isIssue });
			return !!consumptionData?.value?.availableLimit;
		} catch (err) {
			if (err?.response?.data?.errors?.length) {
				err?.response?.data?.errors.map(error => mc.error(error.message))
			} else {
				mc.error("Falha ao confirmar a sua cotação, tente novamente!")
			}
			return false;
		}
	}

	const handleSigningPolicyDocument = async () => {
		const { data: dataDocuments } = await useGetDocumentsAsyncRequest(null, {
			idDomain: 362
		});

		let responseStatus;
		if (dataDocuments?.value?.length) {
			let requestCount = 0;
			const [policyPackDocument] = dataDocuments?.value;
			while (requestCount === 0 || responseStatus !== 200) {
				try {
					requestCount++;
					if (requestCount > 5) break;
					const { data: signatureResponse } = await useSignatureDocumentSompoRequest({
						idDocument: policyPackDocument?.idDocument
					});
					responseStatus = signatureResponse.ret_code;
				} catch {
					responseStatus = 500;
				}
			}
		}

		if (responseStatus && responseStatus !== 200) {
			mc.error(`Não foi possível gerar/autenticar o endosso, acesse a pasta de documentos e tente novamente`);
		}

		history.push(`/adjustments-and-corrections-policy/${props.match.params.idOperation}`);
	};

	async function quoteIssue() {
		const endTermDate = questionnaire.find(qst => qst.idQuestion === 3448);
		if (endTermDate?.answer && moment(endTermDate.answer).isBefore(new Date(), 'day')) {
			return mc.error(
				'A data do fim de vigência deve ser maior ou igual a data de hoje para a efetivação do endosso'
			);
		}

		// const canConsumeLimit = await handleCheckConsumption(true);
		// if (!canConsumeLimit) return;

		const hasInternalProcessNumberAnswer = questionnaire.find(qst => qst.idQuestion === 3476)?.answer;

		let internalProcessNumberValidate;

		if (hasInternalProcessNumberAnswer) {
			internalProcessNumberValidate = true;
		} else {
			await useRequestSompoGetInternalProcessNumberRequest({
				idOperation: props.match.params.idOperation
			}).then(async (response) => {
				if (response.status !== 200) {
					internalProcessNumberValidate = false;
					return mc.error('Ocorreu um erro na requisição do sistema externo');
				} else {
					internalProcessNumberValidate = true;
				}
			})
		}

		const effectiveDateQuestion = questionnaire.find(qst => qst.idQuestion === 3520)
		if (!effectiveDateQuestion?.answer) {
			effectiveDateQuestion.answer = new Date().toISOString();
			try {
				await useSaveQuestionnaireAnswerRequest([effectiveDateQuestion]);
			} catch (e) {
				mc.success("Ocorreu um erro durante a solicitação.");
				return;
			}
		}

		if (!internalProcessNumberValidate) {
			return mc.error('Número de processo interno não foi gerado');
		} else {
			// ######################## Issue Quote Policy ##########################################
			mc.success("Efetivação de endosso em andamento.");
			await useRequestSompoGetIssueQuotePolicyRequest({
				idOperation: props.match.params.idOperation
			}).then(async (response) => {
				if (response.status === 200 && response.data?.ret_value?.policyNumber) {
					const referenceNumber = response.data?.ret_value?.policyNumber;
					
					useRequestIssueActionRequest({
						idOperation: props.match.params.idOperation,
						referenceNumber,
						isSompoCreatePolicy: true
					}).then(async (response) => {
						if (response.status === 200) {
							useUpdateOperationRequest({ idDomainStatus: 187 }).then(() => {
								handleSigningPolicyDocument();
							}).catch(error => {
								console.log(error);
							});
						} else {
							mc.error('Ocorreu um erro durante a solicitação.');
						}
					});
				} else {
					return mc.error('Erro na requisição do sistema externo. Não foi possível emitir o número da apólice.');
				}
			}).catch((e) => {
				if (e.response?.data?.ret_msg_details.includes('código seguradora')) {
					return mc.error(e.response?.data?.ret_msg_details.split('"')[1].slice(5));
				} 
				return mc.error(`Erro na requisição do sistema externo. Não foi possível emitir o número da apólice.`);
			})
		}
	}

	const hire = async (values) => {
		try {
			await quoteIssue();
		} catch (e) {
			updateIsLoadingStatus(false);
			mc.error(`Ocorreu um erro durante a solicitação.`);
			console.log("hire error", e);
		}
	}

	return (
		<Layout
			title={""}
			subtitle={`${operation?.productName || ""}`}
			idOperation={operation?.idOperation}
		>
			<StepNavigation
				stage={2}
				idOperation={props?.match?.params?.idOperation}
				permissions={permissions}
			/>

			<BrokingSummary
				idProduct={props?.match?.params?.idProduct}
				idOperation={props?.match?.params?.idOperation}
				history={history}
				permissions={permissions}
			/>

			<Content>
				<Formik
					validateOnChange={false}
					innerRef={formikRef}
					initialValues={{}}
					enableReinitialize={true}
					onSubmit={() => setDialogConfirmationEmission({ visible: true })}
				>
					{({ values, errors, setFieldValue, setFieldError }) => {
						return (
							<Form onKeyDown={(e) => {
								if (e.key === 'Enter') e.preventDefault();
							}}>
								<ModalEditConfirmation
									show={dialogConfirmationEmission.visible}
									title={'EFETIVAR ENDOSSO'}
									messages={[() => {
										return (
											<p style={{ display: 'flex', fontSize: '16px' }}>
												Você deseja confirmar a efetivação deste endosso?
											</p>
										)
									}
									]}
									onConfirm={() => hire(values)}
									onCancel={() => setDialogConfirmationEmission({ ...dialogConfirmationEmission, visible: false })}
								/>
								<FileModal documents={documents} />

								<ButtonContainer style={{ padding: '0 10px' }}>
									<Button forth style={{ width: 'auto' }} onClick={() => handleBack()}> &lt; VOLTAR </Button>


									<ButtonContent>
										<HasPermission permission={!isBound}>
											{(operation?.idOperation) &&
											<LostCancelButton idQuestion={3458} idOperation={props.match?.params?.idOperation} title={'PERDIDO'} redirectTo={"/list"} />}
											

											<HasPermission permission={(permissions.ENDORSEMENT_APPROVE_REJECT || operation.idDomainStatus == 384) && permissions.EXECUTE_ENDORSEMENT}>
												<Button
													id="btnSave"
													type="submit"
													onClick={() => {
														validationSchema.current.validate(values).catch((e) => {
															console.log('validation error', e)
															mc.error('Por favor, preencha todos os campos obrigatórios (*)')
														})
													}}
													style={{ marginLeft: 15 }}
													primary
												>
													EFETIVAR ENDOSSO
												</Button>
											</HasPermission>
										</HasPermission>
									</ButtonContent>
								</ButtonContainer>
							</Form>
						)
					}}
				</Formik>
			</Content>
		</Layout>
	)
}
